import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Field from 'lib/struct/form/fields/Field';
import Select from 'lib/struct/form/Select';

@observer export default class MarkupTemplateThemeSelect extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		return (
			<Field label='Тема дизайна'>
				<Select
					options={context.theme_options}
					value={context.current_theme_id}
					onChange={e => context.updateCurrentTheme(e.target.value)}
					disabled={context.markup_templates_is_in_loading}
				/>
			</Field>
		);
	}
}